<template>
  <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M52.6411 11.4153C54.8876 10.1505 57.4221 9.48608 60.0001 9.48608C62.5781 9.48608
        65.1126 10.1505 67.3591 11.4153C69.6055 12.6801 71.4881 14.5025 72.8251 16.7067L72.8395
        16.7304L115.189 87.4304L115.23 87.4995C116.54 89.7677 117.233 92.3392 117.24 94.9584C117.247
        97.5776 116.569 100.153 115.272 102.428C113.975 104.704 112.105 106.6 109.847 107.928C107.59
        109.257 105.024 109.971 102.405 110L102.35 110L17.5951 110C14.9761 109.971 12.4103 109.257
        10.153 107.928C7.89559 106.6 6.02537 104.704 4.72835 102.428C3.43133 100.153 2.75274 97.5776
        2.76007 94.9584C2.7674 92.3392 3.46041 89.7677 4.77015 87.4995L4.81077 87.4304L47.1608
        16.7304L51.45 19.2997L47.1751 16.7067C48.5121 14.5025 50.3947 12.6801 52.6411 11.4153ZM55.7312
        21.883L13.4135 92.5289C12.9877 93.2779 12.7624 94.1244 12.76 94.9864C12.7576 95.8595 12.9838
        96.7179 13.4161 97.4764C13.8485 98.2349 14.4719 98.867 15.2243 99.3097C15.9702 99.7486 16.8171
        99.9863 17.6821 99.9998H102.318C103.183 99.9863 104.03 99.7486 104.776 99.3097C105.528 98.867
        106.152 98.2349 106.584 97.4764C107.016 96.7179 107.243 95.8595 107.24 94.9864C107.238 94.1245
        107.013 93.2781 106.587 92.5292L64.2751 21.8929C64.2731 21.8896 64.2711 21.8863 64.2691 21.883C63.8238
        21.1527 63.1985 20.5488 62.4531 20.1292C61.7043 19.7076 60.8594 19.4861 60.0001 19.4861C59.1408
        19.4861 58.2959 19.7076 57.5471 20.1292C56.8017 20.5488 56.1765 21.1527 55.7312 21.883Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M60 40C62.7614 40 65 42.2386 65 45V65C65 67.7614 62.7614 70 60 70C57.2386 70 55 67.7614 55 65V45C55 42.2386 57.2386 40 60 40Z" 
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M55 85C55 82.2386 57.2386 80 60 80H60.05C62.8114 80 65.05 82.2386 65.05 85C65.05 87.7614 62.8114 90 60.05 90H60C57.2386 90 55 87.7614 55 85Z"
      fill="white"
    />
  </svg>
</template>
